import { ref, onMounted, onUnmounted } from 'vue';

export default function useIsMobile(mobileWidth = 768) {
  const isMobile = ref(false);

  function updateIsMobile() {
    isMobile.value = window.innerWidth <= mobileWidth; // Adjust this value as needed
  }

  onMounted(() => {
    window.addEventListener('resize', updateIsMobile);
    updateIsMobile();
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateIsMobile);
  });

  return {
    isMobile,
  };
}
